module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "borrar-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "borrar-mapa"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mapa.nomAplicacio))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('nota')))]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.borrarMapa
    }
  }, [_vm._v(_vm._s(_vm.$t('esborrar')))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "borrar-colaborador-mapa"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('titleColaboratiu')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('messageColaboratiu')) + _vm._s(_vm.mapa.nomAplicacio) + "?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('notaColaboratiu')))]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.borrarColaboradorMapa
    }
  }, [_vm._v(_vm._s(_vm.$t('esborrarColaboratiu')))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.dismiss
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelar')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3507868"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/borrar-modal/borrar-modal.vue
// module id = 318
// module chunks = 0